import * as Yup from 'yup';

export const RegisterSchema = (t: any) => Yup.object().shape({
  fullName: Yup.string()
    .required('Имя и Фамилия обязательны для заполнения'),
  email: Yup.string()
    .email(t('noCorrectEmail'))
    .required(t('emailRequired')),
  password: Yup.string()
    .required(t('passwordRequired'))
    .min(6, t('passwordTooShort')),
  accept: Yup.boolean()
    .oneOf([true], 'Необходимо согласие с правилами'),
});

